import { IParamsGetLimitDiscount } from 'app/api/marketing/limit-discount/model'

export const LimitDiscountKeys = {
  allLimitDiscounts: ['LimitDiscounts'] as const,
  listLimitDiscount: () =>
    [...LimitDiscountKeys.allLimitDiscounts, 'LimitDiscountsList'] as const,
  listLimitDiscounts: (filter?: IParamsGetLimitDiscount) =>
    [...LimitDiscountKeys.listLimitDiscount(), { filter }] as const,
}
